(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-banner"]) return;
  try {
    
  if (!customElements.get('weaver-collection-banner')) {
    customElements.define('weaver-collection-banner', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller) return;

        this.preview = this.querySelector('[data-cb-preview]');
        this.full = this.querySelector('[data-cb-full]');
        this.toggle = this.querySelector('[data-cb-toggle]');

        if (!this.preview || !this.full || !this.toggle) return;

        this.controller = new AbortController();
        this.expanded = this.expanded ?? false;

        this.setExpanded(this.expanded);
        this.toggle.hidden = false;

        this.toggle.addEventListener('click', () => {
          this.setExpanded(!this.expanded);
        }, {
          signal: this.controller.signal
        });
      }

      setExpanded(expanded) {
        this.expanded = expanded;

        this.preview.hidden = expanded;
        this.full.hidden = !expanded;

        this.toggle.setAttribute('aria-expanded', String(expanded));

        this.toggle.textContent = expanded
          ? this.toggle.dataset.labelLess
          : this.toggle.dataset.labelMore;
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-filters-test"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('weaver-category-carousel')) {
    customElements.define('weaver-category-carousel', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.setup());
      }

      setup() {
        if (!this.isConnected || this.controller) return;

        this.controller = new AbortController();
        const signal = this.controller.signal;

        this.setupDescription(signal);

        this.track = this.querySelector('[data-filter-track]');
        this.carousel = this.querySelector('[data-filter-carousel]');

        if (!this.track || !this.carousel) return;

        this.controls = this.querySelector('[data-filter-controls]');
        this.previous = this.querySelector('[data-filter-prev]');
        this.next = this.querySelector('[data-filter-next]');
        this.rtl = getComputedStyle(this.track).direction === 'rtl';

        this.scheduleUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };

        this.track.addEventListener('scroll', this.scheduleUpdate, {
          passive: true,
          signal
        });

        this.next?.addEventListener('click', () => this.move(1), { signal });
        this.previous?.addEventListener('click', () => this.move(-1), { signal });

        this.track.addEventListener('keydown', (event) => {
          if (
            event.target !== this.track ||
            event.altKey ||
            event.ctrlKey ||
            event.metaKey
          ) return;

          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();

            const direction = event.key === 'ArrowRight' ? 1 : -1;
            this.move(this.rtl ? -direction : direction);
          }
        }, { signal });

        this.observer = new ResizeObserver(this.scheduleUpdate);
        this.observer.observe(this);
        this.observer.observe(this.track);

        this.update();
      }

      setupDescription(signal) {
        this.descriptionPreview = this.querySelector('[data-description-preview]');
        this.descriptionFull = this.querySelector('[data-description-full]');
        this.descriptionToggle = this.querySelector('[data-description-toggle]');

        if (
          !this.descriptionPreview ||
          !this.descriptionFull ||
          !this.descriptionToggle
        ) return;

        this.descriptionExpanded = this.descriptionExpanded ?? false;

        this.setDescriptionExpanded(this.descriptionExpanded);
        this.descriptionToggle.hidden = false;

        this.descriptionToggle.addEventListener('click', () => {
          this.setDescriptionExpanded(!this.descriptionExpanded);
        }, { signal });
      }

      setDescriptionExpanded(expanded) {
        this.descriptionExpanded = expanded;

        this.descriptionPreview.hidden = expanded;
        this.descriptionFull.hidden = !expanded;

        this.descriptionToggle.setAttribute(
          'aria-expanded',
          String(expanded)
        );

        this.descriptionToggle.textContent = expanded
          ? this.descriptionToggle.dataset.labelLess
          : this.descriptionToggle.dataset.labelMore;
      }

      update() {
        if (!this.track) return;

        if (this.controls) {
          this.controls.hidden =
            this.track.scrollWidth <= this.carousel.clientWidth + 1;
        }

        const maximum = Math.max(
          0,
          this.track.scrollWidth - this.track.clientWidth
        );

        const position = Math.abs(this.track.scrollLeft);

        if (this.previous) {
          this.previous.disabled = position <= 1;
        }

        if (this.next) {
          this.next.disabled = position >= maximum - 1;
        }
      }

      move(direction) {
        const item = this.track.querySelector('.wls-filter__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;

        const distance =
          (item ? item.getBoundingClientRect().width : this.track.clientWidth) +
          gap;

        this.track.scrollBy({
          left: distance * direction * (this.rtl ? -1 : 1),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
